const Vr15 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-15/PNG%20n.3/3d%2015-3/publish%2015-3/index.htm`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 15 Tour"
        ></iframe>
      </div>
    );
};

export default Vr15;
